<template>
    <div>
        <div class="row">

            <design-2021-britannica-school-component
                :school-id-in="schoolIdIn"
            ></design-2021-britannica-school-component>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-britannica-index-component",
    props: [
        'schoolIdIn'
    ]
}
</script>

<style scoped>
</style>